// ── WaitingBadge ─────────────────────────────────────────────────────────────
// Colour-coded waiting duration: green <3d | amber 3-7d | red >7d
export function WaitingBadge({ submittedAt }: { submittedAt?: Date | null }) {
  if (!submittedAt) return <span className="text-xs text-muted-foreground">—</span>;

  const totalDays = Math.floor((Date.now() - submittedAt.getTime()) / (1000 * 60 * 60 * 24));
  const weeks = Math.floor(totalDays / 7);
  const days = totalDays % 7;

  let label: string;
  if (totalDays === 0) label = '< 1d';
  else if (weeks === 0) label = `${days}d`;
  else if (days === 0) label = `${weeks}w`;
  else label = `${weeks}w ${days}d`;

  const colour =
    totalDays > 7  ? 'text-red-600 dark:text-red-400 font-semibold' :
    totalDays >= 3 ? 'text-amber-600 dark:text-amber-400 font-medium' :
                     'text-green-600 dark:text-green-500';

  return <span className={`text-xs tabular-nums ${colour}`}>{label}</span>;
}
